/**
 * Card Shop — o mesmo carrossel do card slider, com botão de pagamento.
 * A confirmação e a matrícula ficam no Moodle e no servidor.
 */
import { CARD_SLIDER_BOOT, CARD_SLIDER_CSS, CARD_SLIDER_MAX_PER_PAGE, resolveScaledFontPx } from './cardSliderWidget';

function clampInt(value, min, max, fallback) {
  const n = parseInt(value, 10);
  if (Number.isNaN(n)) return fallback;
  return Math.max(min, Math.min(max, n));
}

function escText(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escAttr(value) {
  return escText(value).replace(/"/g, '&quot;');
}

function moneyLabel(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return `R$ ${n.toFixed(2).replace('.', ',')}`;
}

export const CARD_SHOP_CSS = `
.madri-card-shop__price,.madri-moodle-layout .madri-card-shop__price{margin:0;font-weight:800;font-size:var(--cs-price-size,18px);line-height:inherit;color:var(--cs-price,var(--cs-title,#0f172a)) !important}
.madri-shop-modal{position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px}
.madri-shop-modal__box{background:#fff;color:#0f172a;border-radius:12px;padding:20px;width:min(420px,100%);max-height:min(90vh,640px);overflow:auto;box-shadow:0 20px 50px rgba(0,0,0,.25);display:flex;flex-direction:column;gap:10px;box-sizing:border-box}
.madri-shop-modal__box h3{margin:0;font-size:18px}
.madri-shop-modal__box input{border:1px solid #cbd5e1;border-radius:8px;padding:8px 10px;font:inherit}
.madri-shop-modal__actions{display:flex;gap:8px;justify-content:flex-end}
.madri-shop-modal__actions button{border:0;border-radius:8px;padding:8px 14px;font-weight:700;cursor:pointer}
.madri-shop-modal__go{background:#2563eb;color:#fff}
.madri-shop-modal__stop{background:#e2e8f0;color:#0f172a}
.madri-shop-modal__note{font-size:14px;line-height:1.4}
`.replace(/\s+/g, ' ').trim();

const SHOP_BOOT = `<script>
(function(){
  function boot(root) {
    if (!root || root.getAttribute('data-shop-ready') === '1') return;
    root.setAttribute('data-shop-ready', '1');
    var widget = root.getAttribute('data-shop-widget') || 'shop';
    var LS = 'gepetto_cardshop_pend';
    function label(name, fallback) {
      return root.getAttribute(name) || fallback;
    }
    function sesskey() {
      var sk = window.geppettoMoodleSesskey || root.getAttribute('data-shop-sesskey') || '';
      if (!sk || String(sk).indexOf('[') >= 0) return '';
      return sk;
    }
    function ajaxUrl() {
      var sk = sesskey();
      var base = (window.geppettoMoodleWwwroot || window.location.origin || '').replace(/\\/$/, '');
      if (!sk) return '';
      return base + '/lib/ajax/service.php?sesskey=' + encodeURIComponent(sk);
    }
    function cmid() {
      var n = parseInt(window.geppettoMoodleCmid, 10);
      if (!(n > 0)) n = parseInt(root.getAttribute('data-shop-cmid') || '', 10);
      return n > 0 ? n : 0;
    }
    function extraFields() {
      try {
        var list = JSON.parse(root.getAttribute('data-shop-fields') || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) { return []; }
    }
    function call(method, args) {
      var url = ajaxUrl();
      if (!url || !cmid()) return Promise.reject(new Error('moodle'));
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify([{ index: 0, methodname: method, args: args }])
      }).then(function(r) { return r.json(); }).then(function(data) {
        if (!data || !data[0]) throw new Error('empty');
        if (data[0].error) throw new Error(data[0].exception && data[0].exception.message ? data[0].exception.message : 'error');
        return data[0].data || {};
      });
    }
    function readMap() {
      try { return JSON.parse(localStorage.getItem(LS) || '{}') || {}; } catch (e) { return {}; }
    }
    function writeMap(map) { localStorage.setItem(LS, JSON.stringify(map)); }
    function showNote(text) {
      var note = root.querySelector('[data-shop-note]');
      if (!note) return;
      note.textContent = text || '';
      note.style.display = text ? 'block' : 'none';
    }
    function poll(ext) {
      var tries = 0;
      var timer = setInterval(function() {
        tries += 1;
        if (tries > 40) { clearInterval(timer); return; }
        call('mod_gepettoresource_cardshop_payment_status', { cmid: cmid(), externalreference: ext }).then(function(d) {
          if (!d || !d.paid) return;
          clearInterval(timer);
          var map = readMap();
          delete map[widget];
          writeMap(map);
          showNote(d.message || label('data-shop-done', 'Pagamento confirmado.'));
        }).catch(function() {});
      }, 4000);
    }
    function openForm(btn) {
      if (document.querySelector('.madri-shop-modal')) return;
      if (!ajaxUrl() || !cmid()) {
        window.alert(label('data-shop-moodle', 'O pagamento abre na página publicada no Moodle.'));
        return;
      }
      var modal = document.createElement('div');
      modal.className = 'madri-shop-modal';
      var box = document.createElement('div');
      box.className = 'madri-shop-modal__box';
      var title = document.createElement('h3');
      title.textContent = btn.getAttribute('data-title') || label('data-shop-title', 'Seus dados');
      box.appendChild(title);
      function field(key, type, placeholder, required) {
        var input = document.createElement('input');
        input.type = type;
        input.placeholder = placeholder;
        input.required = !!required;
        input.setAttribute('data-shop-field', key);
        box.appendChild(input);
        return input;
      }
      field('name', 'text', label('data-shop-name', 'Nome e sobrenome'), true);
      field('email', 'email', label('data-shop-email', 'E-mail'), true);
      field('phone', 'tel', label('data-shop-phone', 'Telefone'), false);
      extraFields().forEach(function(item) {
        if (!item || !item.shortname || item.hidden) return;
        field('pf:' + item.shortname, 'text', item.label || item.shortname, false);
      });
      var actions = document.createElement('div');
      actions.className = 'madri-shop-modal__actions';
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'madri-shop-modal__stop';
      cancel.textContent = label('data-shop-close', 'Cancelar');
      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'madri-shop-modal__go';
      go.textContent = label('data-shop-send', 'Ir para o pagamento');
      actions.appendChild(cancel);
      actions.appendChild(go);
      box.appendChild(actions);
      modal.appendChild(box);
      document.body.appendChild(modal);
      cancel.addEventListener('click', function() { modal.remove(); });
      modal.addEventListener('click', function(ev) { if (ev.target === modal) modal.remove(); });
      go.addEventListener('click', function() {
        var name = box.querySelector('[data-shop-field="name"]').value.trim();
        var email = box.querySelector('[data-shop-field="email"]').value.trim().toLowerCase();
        var phone = box.querySelector('[data-shop-field="phone"]').value.trim();
        var profile = [];
        extraFields().forEach(function(item) {
          if (!item || !item.hidden || !item.shortname) return;
          var fixedValue = String(item.value || '').trim();
          if (fixedValue) profile.push({ shortname: item.shortname, value: fixedValue });
        });
        box.querySelectorAll('[data-shop-field^="pf:"]').forEach(function(input) {
          profile.push({ shortname: input.getAttribute('data-shop-field').slice(3), value: input.value.trim() });
        });
        if (name.length < 2 || email.indexOf('@') < 0) return;
        go.disabled = true;
        call('mod_gepettoresource_cardshop_payment_start', {
          cmid: cmid(),
          widgetid: widget,
          cardindex: parseInt(btn.getAttribute('data-index') || '0', 10) || 0,
          amount: parseFloat(btn.getAttribute('data-amount') || '0') || 0,
          gateway: btn.getAttribute('data-gateway') === 'mercadopago' ? 'mercadopago' : 'asaas',
          description: btn.getAttribute('data-title') || 'Card Shop',
          buyername: name,
          buyeremail: email,
          buyerphone: phone,
          buyerdocument: '',
          courseid: parseInt(btn.getAttribute('data-course') || '0', 10) || 0,
          savename: 1,
          savephone: 1,
          documentfield: '',
          profilefields: JSON.stringify(profile)
        }).then(function(d) {
          if (!d || !d.invoice_url) throw new Error('url');
          var map = readMap();
          map[widget] = d.external_reference;
          writeMap(map);
          window.location.href = d.invoice_url;
        }).catch(function(err) {
          go.disabled = false;
          window.alert(err && err.message && err.message !== 'moodle' ? err.message : label('data-shop-fail', 'Não foi possível abrir o pagamento.'));
        });
      });
    }
    root.addEventListener('click', function(ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-shop-pay]') : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      openForm(btn);
    });
    var pending = readMap()[widget];
    if (pending && ajaxUrl() && cmid()) {
      showNote(label('data-shop-wait', 'Confirmando o pagamento...'));
      poll(pending);
    }
  }
  window.madriCardShopBoot = boot;
})();
</script>`;

function cardHtml(card, index) {
  const image = String(card?.imageUrl || '').trim();
  const title = String(card?.title || '').trim();
  const text = String(card?.text || '').trim();
  const button = String(card?.buttonLabel || '').trim() || 'Comprar';
  const gateway = card?.gateway === 'mercadopago' ? 'mercadopago' : 'asaas';
  const amount = Math.round((Number(card?.price) || 0) * 100) / 100;
  const courseId = Math.max(0, parseInt(card?.courseId, 10) || 0);
  const imageHtml = image
    ? `<img class="madri-card-slider__media" src="${escAttr(image)}" alt="${escAttr(title || '')}">`
    : '<div class="madri-card-slider__ph"></div>';
  const price = moneyLabel(amount);
  const buttonHtml = `<button type="button" class="madri-card-slider__btn" data-shop-pay="1" data-index="${index}" data-amount="${amount}" data-gateway="${gateway}" data-course="${courseId}" data-title="${escAttr(title || button)}">${escText(button)}</button>`;
  return `<div class="madri-card-slider__card">${imageHtml}<div class="madri-card-slider__body">${title ? `<div class="madri-card-slider__title">${escText(title)}</div>` : ''}${price ? `<div class="madri-card-shop__price">${escText(price)}</div>` : ''}${text ? `<div class="madri-card-slider__text">${escText(text)}</div>` : ''}${buttonHtml}</div></div>`;
}

export function createDefaultCardShopContent(labels = {}) {
  const card = (title) => ({
    imageUrl: '',
    title,
    text: labels.cardText || 'Descreva o que a pessoa leva ao comprar.',
    price: 97,
    gateway: 'asaas',
    courseId: 0,
    buttonLabel: labels.button || 'Comprar',
  });
  return {
    layout: 'netflix',
    cardAlign: 'left',
    perPage: 3,
    perPageMobile: 1,
    gap: 16,
    radius: 14,
    imageHeight: 160,
    peek: 56,
    autoplay: false,
    autoplayMs: 4000,
    loop: true,
    showArrows: true,
    showDots: true,
    hoverLift: true,
    shadow: true,
    cardBg: '#ffffff',
    titleColor: '#0f172a',
    textColor: '#475569',
    priceColor: '#0f172a',
    btnBg: '#2563eb',
    btnColor: '#ffffff',
    arrowBg: '#ffffff',
    arrowColor: '#0f172a',
    dotColor: '#cbd5e1',
    dotActive: '#2563eb',
    profileFields: [],
    cards: [
      card(labels.card1 || 'Oferta 1'),
      card(labels.card2 || 'Oferta 2'),
    ],
  };
}

function profileFieldsOf(content) {
  const raw = Array.isArray(content?.profileFields) ? content.profileFields : [];
  const out = [];
  raw.forEach((item) => {
    const shortname = String(item?.shortname || '').toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 40);
    const label = String(item?.label || '').trim().slice(0, 80);
    const hidden = item?.hidden === true;
    const value = String(item?.value || '').trim().slice(0, 255);
    if (!shortname || out.some((field) => field.shortname === shortname)) return;
    out.push({ shortname, label: label || shortname, hidden, value });
  });
  if (!out.length) {
    const legacy = String(content?.documentField || '').toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 40);
    if (legacy) out.push({ shortname: legacy, label: String(content?.formDocument || 'Documento').slice(0, 80) });
  }
  return out.slice(0, 8);
}

export function buildCardShopInnerHtml(content, widgetId) {
  const c = content || {};
  const cards = Array.isArray(c.cards) ? c.cards.slice(0, 12) : [];
  const layout = c.layout === 'centered' ? 'centered' : 'netflix';
  const id = `shop_${String(widgetId || 'shop').replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const vars = [
    `--cs-card:${c.cardBg || '#ffffff'}`,
    `--cs-title:${c.titleColor || '#0f172a'}`,
    `--cs-text:${c.textColor || '#475569'}`,
    `--cs-price:${c.priceColor || c.titleColor || '#0f172a'}`,
    `--cs-title-size:${resolveScaledFontPx(c, 'cardTitleFontPx', 16, 1)}px`,
    `--cs-text-size:${resolveScaledFontPx(c, 'cardTextFontPx', 14, 0.875)}px`,
    `--cs-price-size:${resolveScaledFontPx(c, 'cardPriceFontPx', 18, 1.125)}px`,
    `--cs-btn:${c.btnBg || '#2563eb'}`,
    `--cs-btn-text:${c.btnColor || '#ffffff'}`,
    `--cs-arrow:${c.arrowBg || '#ffffff'}`,
    `--cs-arrow-text:${c.arrowColor || '#0f172a'}`,
    `--cs-dot:${c.dotColor || '#cbd5e1'}`,
    `--cs-dot-on:${c.dotActive || '#2563eb'}`,
    `--cs-radius:${clampInt(c.radius, 0, 32, 14)}px`,
    `--cs-img:${clampInt(c.imageHeight, 80, 420, 160)}px`,
  ].join(';');
  const classes = [
    'madri-card-slider',
    'madri-card-shop',
    layout === 'centered' ? 'madri-card-slider--centered' : 'madri-card-slider--netflix',
    c.cardAlign === 'center' ? 'madri-card-slider--center-text' : '',
    c.shadow === false ? '' : 'madri-card-slider--shadow',
    c.hoverLift === false ? '' : 'madri-card-slider--lift',
  ].filter(Boolean).join(' ');
  const arrows = c.showArrows === false ? '' : '<button type="button" class="madri-card-slider__arrow madri-card-slider__arrow--prev" data-cs="prev" aria-label="Anterior">‹</button><button type="button" class="madri-card-slider__arrow madri-card-slider__arrow--next" data-cs="next" aria-label="Próximo">›</button>';
  const dots = c.showDots === false ? '' : '<div class="madri-card-slider__dots" data-cs="dots"></div>';
  const autoplay = c.autoplay ? clampInt(c.autoplayMs, 1200, 20000, 4000) : 0;
  const attrs = [
    `id="${id}"`,
    `class="${classes}"`,
    `style="${escAttr(vars)}"`,
    'data-madri-card-slider="1"',
    `data-layout="${layout}"`,
    `data-per="${clampInt(c.perPage, 1, CARD_SLIDER_MAX_PER_PAGE, 3)}"`,
    `data-per-mobile="${clampInt(c.perPageMobile, 1, CARD_SLIDER_MAX_PER_PAGE, 1)}"`,
    `data-gap="${clampInt(c.gap, 0, 48, 16)}"`,
    `data-peek="${clampInt(c.peek, 12, 180, 56)}"`,
    `data-loop="${c.loop === false ? '0' : '1'}"`,
    `data-autoplay="${autoplay}"`,
    `data-shop-widget="${escAttr(widgetId || id)}"`,
    'data-shop-cmid="[[GEPPETTO_CMID]]"',
    'data-shop-sesskey="[[GEPPETTO_SESSKEY]]"',
    `data-shop-fields="${escAttr(JSON.stringify(profileFieldsOf(c)))}"`,
    `data-shop-title="${escAttr(c.formTitle || 'Seus dados para a matrícula')}"`,
    `data-shop-name="${escAttr(c.formName || 'Nome e sobrenome')}"`,
    `data-shop-email="${escAttr(c.formEmail || 'E-mail')}"`,
    `data-shop-phone="${escAttr(c.formPhone || 'Telefone')}"`,
    `data-shop-doc="${escAttr(c.formDocument || 'CPF ou documento')}"`,
    `data-shop-send="${escAttr(c.formSend || 'Ir para o pagamento')}"`,
    `data-shop-close="${escAttr(c.formClose || 'Cancelar')}"`,
    `data-shop-wait="${escAttr(c.formWait || 'Confirmando o pagamento...')}"`,
    `data-shop-done="${escAttr(c.formDone || 'Pagamento confirmado. Se a conta for nova, o Moodle envia o e-mail para criar a senha.')}"`,
    `data-shop-fail="${escAttr(c.formFail || 'Não foi possível abrir o pagamento.')}"`,
    `data-shop-moodle="${escAttr(c.formMoodle || 'O pagamento abre na página publicada no Moodle.')}"`,
    'tabindex="0"',
  ].join(' ');
  return `<style>${CARD_SLIDER_CSS}${CARD_SHOP_CSS}</style>${CARD_SLIDER_BOOT}${SHOP_BOOT}<div ${attrs}><div class="madri-card-slider__viewport" data-cs="viewport"><div class="madri-card-slider__track" data-cs="track">${cards.map((card, index) => cardHtml(card, index)).join('')}</div></div>${arrows}${dots}<div class="madri-shop-modal__note" data-shop-note style="display:none"></div></div><script>if(window.madriCardSliderBoot){window.madriCardSliderBoot(document.getElementById('${id}'));}if(window.madriCardShopBoot){window.madriCardShopBoot(document.getElementById('${id}'));}</script>`;
}
